import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PermissionModalProvider } from "./context/PermissionModalContext";
import { BrowserRouter } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <PermissionModalProvider>
      <App />
    </PermissionModalProvider>
  </BrowserRouter >
);

reportWebVitals();
